import videojs from 'video.js';

export default {
  init() {
  },
  finalize() {
    $('.testimonials-slider').slick({
      slide: '.testimonial',
      infinite: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 7000,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js